document.addEventListener('DOMContentLoaded', function() {
    
    // Config
    const config = {
        ajaxUrl: saborlistaAjax.ajaxUrl || '/wp-admin/admin-ajax.php',
        nonce: saborlistaAjax.commentNonce || '',
        action: 'saborlista_load_comments',
        contextAction: 'saborlista_get_comment_context'
    };

    handleInitialHash();
    window.addEventListener('hashchange', handleInitialHash);

    function commentErrorMessage(data, fallback) {
        if (data && data.data && typeof data.data === 'object' && data.data.message) {
            return data.data.message;
        }
        if (data && typeof data.data === 'string' && data.data) {
            return data.data;
        }
        return fallback;
    }

    function showCommentError(message) {
        if (window.SaborlistaNotifications) {
            window.SaborlistaNotifications.error(message);
        } else {
            alert(message);
        }
    }

    /**
     * Event Delegation
     */
    document.body.addEventListener('click', function(event) {
        
        // Reply Button
        const replyLink = event.target.closest('.comment-reply-link');
        if (replyLink) {
            handleReplyClick(event, replyLink);
        }

        // Cancel Reply Button
        const cancelLink = event.target.closest('[id^="cancel-comment-reply-link"]');
        if (cancelLink) {
            handleCancelReply(event, cancelLink);
        }

        // Load More Button
        const loadMoreBtn = event.target.closest('.saborlista-load-more-btn');
        if (loadMoreBtn) {
            handleLoadMore(loadMoreBtn);
        }

        // Read More Button (Truncation)
        const readMoreBtn = event.target.closest('.saborlista-read-more-btn');
        if (readMoreBtn) {
            handleReadMore(readMoreBtn);
        }
    });

    document.body.addEventListener('change', function(event) {
        // Sort Select
        if (event.target.matches('.saborlista-sort-select')) {
            handleSortChange(event.target);
        }
    });

    /**
     * Comment Form Submit (Delegation)
     */
    document.body.addEventListener('submit', function(e) {
        const form = e.target.closest('form');
        if (form && (form.id.startsWith('commentform') || form.classList.contains('comment-form'))) {
            e.preventDefault();
            handleCommentSubmit(form);
        }
    });

    /**
     * Handle Comment Submit
     */
    function handleCommentSubmit(form) {
        const submitBtn = form.querySelector('input[type="submit"], button[type="submit"]');
        const originalText = submitBtn ? (submitBtn.value || submitBtn.textContent) : '';

        if (submitBtn) {
            submitBtn.disabled = true;
            const sendingText = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.sending) || 'Sending...';
            if (submitBtn.tagName === 'INPUT') {
                submitBtn.value = sendingText;
            } else {
                submitBtn.textContent = sendingText;
            }
            submitBtn.classList.add('loading');
        }

        const formData = new FormData(form);
        formData.append('action', 'saborlista_submit_comment');
        
        // Use nonce from config or localized data
        const nonce = config.nonce || (window.saborlistaAjax && window.saborlistaAjax.commentNonce) || '';
        formData.append('security', nonce);

        fetch(config.ajaxUrl, {
            method: 'POST',
            body: formData
        })
        .then(response => response.json().then(data => data).catch(() => {
            throw new Error('invalid_json');
        }))
        .then(data => {
            if (data.success) {
                // Show success message
                if (window.SaborlistaNotifications) {
                    const postedMsg = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.postedSuccessfully) || 'Comment posted successfully';
                    window.SaborlistaNotifications.success(data.data.message || postedMsg);
                }

                // Clear form
                form.reset();

                // Reset reply state if we were replying
                const postIdInput = form.querySelector('input[name="comment_post_ID"]');
                const postId = postIdInput ? postIdInput.value : null;

                const cancelBtn = postId ? (document.getElementById(`cancel-comment-reply-link-${postId}`) || form.querySelector('.cancel-comment-reply-link')) : null;
                if (cancelBtn && cancelBtn.style.display !== 'none') {
                    handleCancelReply(new Event('click'), cancelBtn);
                } else if (form.classList.contains('is-replying') || (form.parentElement && form.parentElement.classList.contains('is-replying'))) {
                    // Fallback for cases where button state might be out of sync
                    const fakeCancel = { 
                        id: `cancel-comment-reply-link-${postId}`, 
                        preventDefault: () => {} 
                    };
                    handleCancelReply(new Event('click'), fakeCancel);
                }
                
                // Update list
                if (data.data.html && postId) {
                    const parentId = data.data.parent_id || '0';
                    const commentHtml = data.data.html;
                    
                    const wrapper = document.getElementById(`saborlista-comments-wrapper-${postId}`);
                    let listContainer;
                    
                    if (parentId === '0' || parentId === 0) {
                        listContainer = document.getElementById(`saborlista-list-${postId}`);
                        if (listContainer) {
                            const temp = document.createElement('div');
                            temp.innerHTML = commentHtml;
                            const newCommentNode = temp.firstElementChild;
                            
                            listContainer.prepend(newCommentNode);
                            
                            const body = newCommentNode.querySelector('.comment-body-wrapper');
                            if (body) {
                                body.classList.add('is-new-comment');
                                body.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }
                            
                            const sortSelect = document.getElementById(`saborlista-sort-${postId}`);
                            if (sortSelect) sortSelect.value = 'new';
                        }
                    } else {
                        let childrenList = document.getElementById(`saborlista-children-${parentId}`);
                        
                        if (!childrenList) {
                            const parentItem = document.getElementById(`comment-${parentId}`);
                            if (parentItem) {
                                childrenList = document.createElement('ul');
                                childrenList.id = `saborlista-children-${parentId}`;
                                childrenList.className = 'children';
                                parentItem.appendChild(childrenList);
                            }
                        }
                        
                        if (childrenList) {
                            const temp = document.createElement('div');
                            temp.innerHTML = commentHtml;
                            const newCommentNode = temp.firstElementChild;
                            
                            childrenList.appendChild(newCommentNode);
                            
                            const body = newCommentNode.querySelector('.comment-body-wrapper');
                            if (body) {
                                body.classList.add('is-new-comment');
                                body.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }
                        }
                    }
                    
                    if (wrapper) {
                        wrapper.style.display = 'block';
                        const header = wrapper.querySelector('.saborlista-comments-header');
                        if (header) header.style.display = 'flex';
                    }
                    
                    document.body.dispatchEvent(new CustomEvent('content-loaded'));
                } else if (postId) {
                    const wrapper = document.getElementById(`saborlista-comments-wrapper-${postId}`);
                    const header = wrapper ? wrapper.querySelector('.saborlista-comments-header') : null;
                    const sortSelect = document.getElementById(`saborlista-sort-${postId}`);

                    if (wrapper) {
                        wrapper.style.display = 'block';
                    }

                    if (header) {
                        header.style.display = 'flex';
                    }

                    if (sortSelect) {
                        handleSortChange(sortSelect, data.data.comment_id);
                    }
                }

                // Send analytics event
                if (window.SaborlistaAnalytics) {
                    window.SaborlistaAnalytics.sendEvent('comment_add', {
                        post_id: postId,
                        comment_id: data.data.comment_id,
                        parent_id: data.data.parent_id || '0'
                    });
                }
            } else {
                const postErrorMsg = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.postError) || 'Error posting comment';
                showCommentError(commentErrorMessage(data, postErrorMsg));
            }
        })
        .catch(error => {
            console.error('Comment submission error:', error);
            const networkErrorMsg = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.networkError) || 'Network error. Please try again.';
            if (window.SaborlistaNotifications) {
                window.SaborlistaNotifications.error(networkErrorMsg);
            } else {
                alert(networkErrorMsg);
            }
        })
        .finally(() => {

            if (submitBtn) {
                submitBtn.disabled = false;
                if (submitBtn.tagName === 'INPUT') {
                    submitBtn.value = originalText;
                } else {
                    submitBtn.textContent = originalText;
                }
                submitBtn.classList.remove('loading');
            }
        });
    }

    /**
     * Handle Load More
     */
    function handleLoadMore(button) {
        if (button.disabled || button.classList.contains('loading')) return;

        const postId = button.getAttribute('data-post-id');
        const parentId = button.getAttribute('data-parent-id');
        const offset = button.getAttribute('data-offset');
        const remaining = parseInt(button.getAttribute('data-remaining'));
        
        // Find current mode from the main list container
        // If parentId is 0, we look at the wrapper's list mode.
        // If parentId > 0, we still look at the wrapper's sort select? 
        // Or assume children inherit mode?
        // The sort select is at the top.
        const wrapper = document.getElementById(`saborlista-comments-wrapper-${postId}`);
        const sortSelect = document.getElementById(`saborlista-sort-${postId}`);
        const mode = sortSelect ? sortSelect.value : 'popular';

        // Set Loading State
        button.classList.add('loading');
        button.disabled = true;
        
        const textSpan = button.querySelector('.saborlista-load-more-text');
        const originalText = textSpan ? textSpan.textContent : button.textContent;
        const loadingText = saborlistaAjax.i18n.loading || 'Loading...';

        if (textSpan) {
            textSpan.textContent = loadingText;
        } else {
            button.textContent = loadingText;
        }

        // Prepare Data
        const formData = new FormData();
        formData.append('action', config.action);
        formData.append('nonce', config.nonce);
        formData.append('post_id', postId);
        formData.append('parent_id', parentId);
        formData.append('offset', offset);
        formData.append('mode', mode);

        // Fetch
        fetch(config.ajaxUrl, {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Append content
                const html = data.data.html;
                const nextOffset = data.data.next_offset;
                const newRemaining = data.data.remaining;

                // Find where to append
                let listContainer;
                let loadMoreWrapper = null;

                if (parentId === '0') {
                    listContainer = document.getElementById(`saborlista-list-${postId}`);
                    loadMoreWrapper = wrapper.querySelector('.saborlista-load-more-btn.root-level');
                } else {
                    listContainer = document.getElementById(`saborlista-children-${parentId}`);
                    if (listContainer) {
                        loadMoreWrapper = listContainer.querySelector('.saborlista-load-more-wrapper');
                    }
                }

                if (listContainer) {
                    // Create a temporary container to parse HTML string into nodes
                    const temp = document.createElement('div');
                    temp.innerHTML = html;
                    
                    while (temp.firstChild) {
                        if (loadMoreWrapper && loadMoreWrapper.parentNode === listContainer) {
                            listContainer.insertBefore(temp.firstChild, loadMoreWrapper);
                        } else {
                            listContainer.appendChild(temp.firstChild);
                        }
                    }
                    
                    // Dispatch content-loaded event for other scripts (like ratings)
                    const event = new CustomEvent('content-loaded');
                    document.body.dispatchEvent(event);
                }

                // Update Button State
                button.setAttribute('data-offset', nextOffset);
                button.setAttribute('data-remaining', newRemaining);

                if (newRemaining <= 0) {
                    button.style.display = 'none';
                } else {
                    // Update text
                    const loadMoreCommentsText = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.loadMoreComments) || 'Load more comments';
                    const loadMoreRepliesText = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.loadMoreReplies) || 'Load more replies';
                    
                    const prefix = parentId === '0' 
                        ? loadMoreCommentsText 
                        : loadMoreRepliesText;
                    
                    const textSpan = button.querySelector('.saborlista-load-more-text');
                    const badgeSpan = button.querySelector('.saborlista-count-badge');
                    
                    if (textSpan) textSpan.textContent = prefix;
                    if (badgeSpan) badgeSpan.textContent = newRemaining;
                    
                    if (!textSpan && !badgeSpan) {
                        button.textContent = `${prefix} (${newRemaining})`;
                    }
                }
            } else {
                console.error('Error loading comments:', data);
                const errorTryAgainMsg = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.errorTryAgain) || 'Error. Try again.';
                button.textContent = errorTryAgainMsg;
            }
        })
        .catch(error => {
            console.error('Network error:', error);
            const errorTryAgainMsg = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.errorTryAgain) || 'Error. Try again.';
            button.textContent = errorTryAgainMsg;
        })
        .finally(() => {
            button.classList.remove('loading');
            button.disabled = false;
            
            const textSpan = button.querySelector('.saborlista-load-more-text');
            const currentText = textSpan ? textSpan.textContent : button.textContent;
            const loadingText = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.loading) || 'Loading...';

            if (currentText === loadingText) {
                if (textSpan) {
                    textSpan.textContent = originalText;
                } else {
                    button.textContent = originalText;
                }
            }
        });
    }

    /**
     * Handle Read More (Truncation)
     */
    function handleReadMore(button) {
        const wrapper = button.closest('.comment-body-wrapper');
        const fullText = wrapper.getAttribute('data-full-text');
        const visibleTextContainer = wrapper.querySelector('.visible-text');

        if (fullText && visibleTextContainer) {
            visibleTextContainer.innerHTML = fullText; // Using innerHTML as content might have tags
            button.style.display = 'none';
        }
    }

    /**
     * Handle Sort Change
     */
    function handleSortChange(select, highlightId = null) {
        const wrapper = select.closest('.saborlista-comments-section');
        const postId = wrapper.getAttribute('data-post-id');
        const mode = select.value;
        const list = document.getElementById(`saborlista-list-${postId}`);
        const rootLoader = wrapper.querySelector('.saborlista-load-more-btn.root-level');

        if (!list) return;

        // Save current height to prevent layout jump
        const currentHeight = list.offsetHeight;
        if (currentHeight > 0) {
            list.style.minHeight = currentHeight + 'px';
        }

        // Hide load more button
        if (rootLoader) rootLoader.style.display = 'none';

        // Create skeleton loader
        const skeletonCount = Math.max(3, Math.ceil(currentHeight / 150));
        let skeletonHTML = '';
        for (let i = 0; i < skeletonCount; i++) {
            skeletonHTML += `
                <li class="saborlista-comment-item depth-1 saborlista-skeleton-loader">
                    <div class="comment-body-wrapper">
                        <div class="comment-meta">
                            <div class="comment-author-info">
                                <div class="comment-avatar skeleton-avatar"></div>
                                <span class="author skeleton-text skeleton-text-short"></span>
                            </div>
                            <div class="comment-meta-actions">
                                <span class="date skeleton-text skeleton-text-very-short"></span>
                            </div>
                        </div>
                        <div class="comment-content">
                            <span class="skeleton-text"></span>
                            <span class="skeleton-text"></span>
                            <span class="skeleton-text skeleton-text-short"></span>
                        </div>
                    </div>
                </li>
            `;
        }

        // Apply skeleton with fade transition
        list.style.opacity = '0.5';
        list.innerHTML = skeletonHTML;

        // Fetch first batch with new mode
        const formData = new FormData();
        formData.append('action', config.action);
        formData.append('nonce', config.nonce);
        formData.append('post_id', postId);
        formData.append('parent_id', 0);
        formData.append('offset', 0);
        formData.append('mode', mode);

        fetch(config.ajaxUrl, {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Remove min-height constraint before inserting new content
                list.style.minHeight = '';
                list.style.opacity = '1';
                list.innerHTML = data.data.html;
                
                // Highlight new comment if provided
                if (highlightId) {
                    const newCommentBody = list.querySelector(`#comment-body-${highlightId}`);
                    if (newCommentBody) {
                        newCommentBody.classList.add('is-new-comment');
                        // Scroll to it
                        newCommentBody.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }

                // Show wrapper and header if they were hidden (first comment case)
                if (data.data.total_count > 0) {
                    if (wrapper) wrapper.style.display = 'block';
                    const header = wrapper ? wrapper.querySelector('.saborlista-comments-header') : null;
                    if (header) header.style.display = 'flex';
                }

                // Restore/Update Load More Button
                if (rootLoader) {
                    rootLoader.setAttribute('data-offset', data.data.next_offset);
                    rootLoader.setAttribute('data-remaining', data.data.remaining);
                    
                    if (data.data.remaining > 0) {
                        rootLoader.style.display = 'inline-block';
                        const loadMoreCommentsText = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.loadMoreComments) || 'Load more comments';
                        const prefix = loadMoreCommentsText;
                        
                        const textSpan = rootLoader.querySelector('.saborlista-load-more-text');
                        const badgeSpan = rootLoader.querySelector('.saborlista-count-badge');
                        
                        if (textSpan) textSpan.textContent = prefix;
                        if (badgeSpan) badgeSpan.textContent = data.data.remaining;
                        
                        if (!textSpan && !badgeSpan) {
                            rootLoader.textContent = `${prefix} (${data.data.remaining})`;
                        }
                    } else {
                        rootLoader.style.display = 'none';
                    }
                }

                // Update Count in Header
                const headerTitle = wrapper.querySelector('.saborlista-comments-title');
                if (headerTitle && data.data.total_count_text) {
                    headerTitle.innerHTML = data.data.total_count_text;
                } else {
                    const countBadge = wrapper.querySelector('.saborlista-count');
                    if (countBadge && data.data.total_count !== undefined) {
                        countBadge.textContent = data.data.total_count;
                    }
                }

                // Show/Hide Filter
                const filterWrapper = wrapper.querySelector('.saborlista-filter-wrapper');
                if (filterWrapper && data.data.total_count !== undefined) {
                    filterWrapper.style.display = data.data.total_count > 3 ? 'flex' : 'none';
                }

                // Dispatch event
                const event = new CustomEvent('content-loaded');
                document.body.dispatchEvent(event);
            } else {
                list.style.minHeight = '';
                list.style.opacity = '1';
                const errorLoadingMsg = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.errorLoadingComments) || 'Error loading comments.';
                list.innerHTML = `<li class="error-placeholder">${errorLoadingMsg}</li>`;
            }
        })
        .catch(error => {
            console.error(error);
            list.style.minHeight = '';
            list.style.opacity = '1';
            const networkErrorShortMsg = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.networkErrorShort) || 'Network error.';
            list.innerHTML = `<li class="error-placeholder">${networkErrorShortMsg}</li>`;
        });
    }

    /**
     * Handle Reply Click
     */
    function handleReplyClick(e, link) {
        e.preventDefault();
        e.stopImmediatePropagation(); // Предотвращаем срабатывание стандартного скрипта WP

        const commentId = link.getAttribute('data-commentid');
        const section = link.closest('.saborlista-comments-section');
        const article = link.closest('article');
        
        const postId = link.getAttribute('data-postid') || 
                       (section ? section.getAttribute('data-post-id') : null) ||
                       (article ? article.id.replace('post-', '') : null);
        
        if (!postId) {
            console.error('InfiniteContent: Could not find postId for comment', commentId);
            return;
        }

        let respond = document.getElementById(`respond-${postId}`);
        
        // Fallback: если по точному ID не нашли, ищем ближайшую форму в статье
        if (!respond && article) {
            respond = article.querySelector('.comment-respond');
        }

        const cancelBtn = document.getElementById(`cancel-comment-reply-link-${postId}`) || 
                          (respond ? (respond.querySelector(`[id="cancel-comment-reply-link-${postId}"]`) || respond.querySelector('#cancel-comment-reply-link') || respond.querySelector('.cancel-comment-reply-link')) : null) ||
                          document.getElementById('cancel-comment-reply-link');
        const commentBody = document.getElementById(`comment-body-${commentId}`);
        
        // Ищем поле parent более гибко
        const parentInput = respond ? (
            respond.querySelector(`input[id^="comment_parent-${postId}"]`) || 
            respond.querySelector('input[name="comment_parent"]') ||
            document.getElementById(`comment_parent-${postId}`)
        ) : null;

        if (respond && commentBody) {
            // Перемещаем форму к комментарию
            commentBody.after(respond);
            
            // Показываем кнопку отмены
            if (cancelBtn) cancelBtn.style.display = 'block';
            
            // Устанавливаем ID родителя
            if (parentInput) parentInput.value = commentId;

            // Фокус на поле ввода
            const textarea = respond.querySelector('textarea');
            if (textarea) textarea.focus();
            
            respond.classList.add('is-replying');
            
            // Прокрутка к форме, если она ушла из вида
            const rect = respond.getBoundingClientRect();
            if (rect.top < 0 || rect.bottom > window.innerHeight) {
                respond.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        } else {
            console.error('InfiniteContent: Could not find respond form or comment body', {postId, respond, commentBody});
        }
    }

    /**
     * Handle Cancel Reply
     */
    function handleCancelReply(e, link) {
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }
        
        let postId = '';
        // Try to get ID from the link ID itself
        if (link && link.id) {
            if (link.id.includes('cancel-comment-reply-link-')) {
                postId = link.id.replace('cancel-comment-reply-link-', '');
            } else if (link.id === 'cancel-comment-reply-link') {
                // If it's the exact ID without suffix, we MUST get it from the form
                const form = link.closest('form') || link.closest('.comment-respond');
                if (form) {
                    const pIdInput = form.querySelector('input[name="comment_post_ID"]');
                    if (pIdInput) postId = pIdInput.value;
                }
            }
        }
        
        // Final fallback for postId
        if (!postId && link && typeof link.closest === 'function') {
            const form = link.closest('form') || link.closest('.comment-respond');
            if (form) {
                const pIdInput = form.querySelector('input[name="comment_post_ID"]');
                if (pIdInput) {
                    postId = pIdInput.value;
                } else {
                    const respondContainer = link.closest('[id^="respond-"]');
                    if (respondContainer) {
                        postId = respondContainer.id.replace('respond-', '');
                    }
                }
            }
        }

        if (!postId) {
            console.error('InfiniteContent: Could not determine postId for cancel reply');
            return;
        }

        // Try both suffixed and base ID for respond container
        const respond = document.getElementById(`respond-${postId}`) || document.getElementById('respond');
        const cancelBtn = document.getElementById(`cancel-comment-reply-link-${postId}`) || 
                          document.getElementById('cancel-comment-reply-link') ||
                          (respond ? (respond.querySelector('.cancel-comment-reply-link') || respond.querySelector('#cancel-comment-reply-link')) : null);
        
        const parentInput = respond ? (
            respond.querySelector(`input[id^="comment_parent-${postId}"]`) || 
            respond.querySelector('input[name="comment_parent"]') ||
            document.getElementById(`comment_parent-${postId}`)
        ) : null;
        
        const initialContainer = document.getElementById(`saborlista-comments-wrapper-${postId}`);

        if (respond) {
            // Возвращаем на место (после секции комментариев)
            if (initialContainer) {
                initialContainer.after(respond);
            }
            
            if (cancelBtn) cancelBtn.style.display = 'none';
            if (parentInput) parentInput.value = '0';
            respond.classList.remove('is-replying');
            
            const form = respond.tagName === 'FORM' ? respond : respond.querySelector('form');
            if (form) form.classList.remove('is-replying');
        } else {
            console.error('InfiniteContent: Could not find respond container to cancel reply', {postId});
        }
    }

    /**
     * Handle Initial Hash Navigation (#comment-ID or #comments-ID)
     */
    async function handleInitialHash() {
        const hash = window.location.hash;
        
        if (!hash || !hash.match(/#comments?-\d+/)) {
            return;
        }

        const commentId = hash.match(/\d+/)[0];

        try {
            const target = await ensureCommentInDOM(commentId);
            if (target) {
                setTimeout(() => {
                    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    target.querySelector('.comment-body-wrapper')?.classList.add('is-new-comment');
                }, 500);
            }
        } catch (err) {
            console.error('Comments System: Error ensuring comment in DOM:', err);
        }
    }

    /**
     * Recursive function to ensure comment and its parents are in DOM
     */
    async function ensureCommentInDOM(commentId) {
        let element = document.getElementById(`comment-${commentId}`);
        if (element) {
            return element;
        }

        const formData = new FormData();
        formData.append('action', config.contextAction);
        formData.append('comment_id', commentId);
        formData.append('security', config.nonce);

        const response = await fetch(config.ajaxUrl, { method: 'POST', body: formData });
        const data = await response.json();

        if (!data.success) {
            throw new Error(data.data?.message || `Failed to fetch comment ${commentId}`);
        }

        const { html, parent_id, post_id } = data.data;

        if (parent_id == 0 || parent_id == '0') {
            const list = document.getElementById(`saborlista-list-${post_id}`);
            if (list) {
                list.insertAdjacentHTML('afterbegin', html);
            }
        } else {
            // Recursive call for parent
            await ensureCommentInDOM(parent_id);
            
            // Now that parent is guaranteed to be in DOM, check again
            element = document.getElementById(`comment-${commentId}`);
            if (!element) {
                let parentList = document.getElementById(`saborlista-children-${parent_id}`);
                if (!parentList) {
                    const parentItem = document.getElementById(`comment-${parent_id}`);
                    if (parentItem) {
                        parentList = document.createElement('ul');
                        parentList.id = `saborlista-children-${parent_id}`;
                        parentList.className = 'children';
                        parentItem.appendChild(parentList);
                    }
                }

                if (parentList) {
                    parentList.insertAdjacentHTML('beforeend', html);
                }
            }
        }

        // Dispatch content-loaded for ratings etc
        document.body.dispatchEvent(new CustomEvent('content-loaded'));
        
        return document.getElementById(`comment-${commentId}`);
    }
});
